import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=e383813e&scoped=true&"
import script from "./Blacklist.vue?vue&type=script&lang=js&"
export * from "./Blacklist.vue?vue&type=script&lang=js&"
import style0 from "./Blacklist.vue?vue&type=style&index=0&id=e383813e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e383813e",
  null
  
)

export default component.exports